import { useEffect,useState } from "react";
import { Link, useSearchParams, useNavigate, useParams,useLocation } from "react-router-dom";
import "./styles/Quoting.css";
import {Policy} from "../../objects/policy";
import {useDispatch, useSelector} from "react-redux";
import StatesDropDown from "../../components/StatesDropDown";
import { FormHelperText, Box, Typography, Modal, Button, TextField, InputLabel, Select, MenuItem, FormControl,AlertColor, Breadcrumbs} from '@mui/material';
import { QuoteService } from "../../services/quoteservice";
import dayjs, { Dayjs } from 'dayjs';
import {DatePicker, DateField,LocalizationProvider  } from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import TermsOfServiceModal from "../../components/modals/TermsOfServiceModal";
import PrivacyPolicyModal from "../../components/modals/PrivacyPolicyModal";
import CreditNoticeModal from "../../components/modals/CreditNoticeModal";
import {Toast, ToastProps} from "../../components/alerts/toast";
import { validateDate } from "@mui/x-date-pickers/internals";
import { MessageBroker } from "../../services/messageBrokerService";
import { logActivityAsync } from "../../objects/events/loadEvents";
import JsonService from "../../services/jsonService";
import { SystemFlags } from "../../objects/systemFlags";

export class QuoteValidate {
    hasEffectiveDate: boolean = true;
    hasFirstName: boolean = true;
    hasLastName: boolean = true;
    hasState: boolean = true;

    effectiveDateError = "Effective Date Is Required";
    firstNameError = "First Name is required";
    lastNameError = "Last Name is required";
    stateError = "State is required";
}

//TODO: move this somewhere
export function addErrorMessage(isAdd: boolean, message: string, errors: string[], setErrors: any){
    var currentErrors = [...errors];
    
    var newErrors = currentErrors.filter(m=> {
        return m !== message
    });
    
    if(message !== "" && isAdd){
        newErrors.push(message);
        setErrors(newErrors);
    }else{
        setErrors(newErrors);
    }
}

function Quote() {
    let quoteService = new QuoteService();
    let messageBroker = new MessageBroker();
    let params = useParams()
    let queryString = window.location.search;
    let queryParams = new URLSearchParams(queryString);
    let dealerId= queryParams.get("dealer_id");
    let referrer= queryParams.get("referrer");
    let quoteNumber= queryParams.get("qn");

    let location = useLocation();
    let navigate = useNavigate();
    const dispatch = useDispatch();
    const policy = useSelector((state: any)=> state.policyReducer) as Policy;
    const systemFlags = useSelector((state:any)=>state.systemFlagsPolicyReducer) as SystemFlags;
    
    const [isTosOpen, setIsTosOpen] = useState(false);
    const [isPrivacyPolicyOpen, setIsPrivacyPolicyOpen] = useState(false);
    const [isCreditNoticeOpen, setIsCreditNoticeOpen] = useState(false);

    const [isLoading, setIsLoading] = useState(false);
    const [policyObject, setPolicyObject] = useState<Policy>();
    const [policyState, setPolicyState] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [suffix, setSuffix] = useState("");
    const [middleInitial, setMiddleInitial] = useState("");
    const [policyNumber, setPolicyNumber] = useState("");
    const [effectiveDate, setEffectiveDate] = useState<Dayjs | null>(null);
    
    const[errors, setErrors] = useState<string[]>([]);
    const[isToastOpen, setIsToastOpen] = useState(false);
    const[toastSeverity, setToastSeverity] = useState<AlertColor>("success");
    const[validationObject, setValidation] = useState<QuoteValidate>(new QuoteValidate());
    const [isDisabledContinue, SetIsDisableContinue ] = useState<boolean>(false);

    useEffect(()=>{
        
        (async()=>{
            await logActivityAsync(policy?.policyNumber ?? "", {
                recordKey: policy?.policyNumber,
                transactionDate: dayjs(new Date().toUTCString()).toISOString(),
                action: "add_activity",
                subject: "Navigation",
                message: "Insured has navigated to the quote screen",
                isException:false,
                error: "",
                level:"INFO",
                isSent: false
            });
        })();
    }, []);

    useEffect(()=>{
        (async ()=>{
            if(params.id !== undefined && params.id !== "" && policy === undefined){
                setPolicyNumber(params.id);
            }
    
            var locationPolicy = location?.state?.data as Policy;
            
            setPolicyObject(policy);
    
            setFirstName(locationPolicy?.insuredFirstName)
            setLastName(locationPolicy?.insuredLastName);
            setSuffix(locationPolicy?.insuredSuffix);
            setMiddleInitial(locationPolicy?.insuredMiddleInitial);
            setEffectiveDate(dayjs(locationPolicy?.effectiveDate));
    
            var mailingAddress = locationPolicy?.addresses?.filter((e)=>{
                return e.type === "mailing"
            })[0];
    
            setPolicyState(mailingAddress?.state ?? "OK");
    
            if(quoteNumber !== null && quoteNumber !== undefined && quoteNumber !== ""){
                var serialize = await quoteService.serializeEncrypted(quoteNumber, true);
                var savedPolicy = serialize.data as Policy;
                
                console.log({ loaded_policy: savedPolicy });

                //dispatch({type: "ORDER_PREFILL", payload: systemFlags})
                //Completed Coverage Verifier

                var isCvComplete =  savedPolicy.flags.some(m=>m.name==="Completed Coverage Verifier");

                if(isCvComplete){
                    dispatch({type: "ORDER_PREFILL", payload: systemFlags})
                }

                setPolicyNumber(quoteNumber);
                setFirstName(savedPolicy?.insuredFirstName)
                setLastName(savedPolicy?.insuredLastName);
                setSuffix(savedPolicy?.insuredSuffix);
                setMiddleInitial(savedPolicy?.insuredMiddleInitial);

                var currentEffectiveDate = new Date(savedPolicy.effectiveDate);
                
                var now = new Date();
                now.setDate(new Date().getDate());

                setEffectiveDate(dayjs(savedPolicy?.effectiveDate));

                if(currentEffectiveDate < now){
                    setEffectiveDate(dayjs(now));
                }

                setPolicyObject(savedPolicy);
            }
        })();
    }, [location])

    function disablePriorDates(date:Dayjs){
        var now = new Date();
        var futureDate=  new Date();
        
        now.setDate(new Date().getDate()-1);
        futureDate.setDate(new Date().getDate() + 30);

        var isInPast = date.toDate() < now || date.toDate() > futureDate;

        return isInPast;
    }

    async function NavgiateToDetailsPage(){
        try{
            var isValid = isFormValid();
            SetIsDisableContinue(true);

            if(!isValid){
                SetIsDisableContinue(false);
                setIsToastOpen(true);
                setToastSeverity("error");
                return;
            }
    
            var newPolicy = (policyObject ?? new Policy())
    
            if(dealerId !== null) {
                newPolicy.leadSourceBusinessName = dealerId; 
            }

            if(referrer !== null) {
                newPolicy.leadSource = referrer;
            }
    
            var clonePolicy = quoteService.updateBasic(newPolicy, 
                effectiveDate, 
                policyState, 
                firstName, 
                lastName, 
                middleInitial, 
                suffix);
    
            
            var rateCycleResponse = await quoteService.getRateCycle(clonePolicy.ratedState, clonePolicy.effectiveDate);
            
            if(!rateCycleResponse.ok){
                SetIsDisableContinue(false);                
                
                var errorResponse = await rateCycleResponse.text();
                var errorObject = JsonService.parseObject(errorResponse);
                
                await logActivityAsync(policy?.policyNumber ?? "", {
                    recordKey: policy?.policyNumber,
                    transactionDate: dayjs(new Date().toUTCString()).toISOString(),
                    action: "error_activity",
                    subject: "Quote Screen - Fetch Rate Cycle",
                    message: `Quote# ${clonePolicy?.policyNumber} - ${clonePolicy?.insuredFirstName} ${clonePolicy?.insuredLastName}, ${clonePolicy?.emailAddress ?? "NO EMAIL"}`,
                    isException: true,
                    error: errorObject?.message ?? "Empty Response",
                    level: "ERROR",
                    isSent: false
                });
                
                var queryParams = new URLSearchParams(window.location.search);
                queryParams.set("returnUrl", "/");            
                SetIsDisableContinue(false);
                navigate("/error?" + queryParams.toString());
                return;
            }
    
            var rateCycleJson = await rateCycleResponse.json();
            var rateCycle = rateCycleJson.rateCycle;
           
            dispatch({type: "UPDATE", payload: clonePolicy})
            dispatch({type: "SET_RATECYCLE", payload: rateCycle})
            let path = policyNumber !== "" ? "/details/" + policyNumber : "/details";
            path = path + window.location.search;
    
            SetIsDisableContinue(false);
    
            navigate(path, {state: clonePolicy});
        }catch(err){
            var queryParams = new URLSearchParams(window.location.search);
            queryParams.set("returnUrl", "/");            
            SetIsDisableContinue(false);
            navigate("/error?" + queryParams.toString());
        }
    }

    function loadingMessage(){
        return <div>Please wait...</div>;
    }

    function onStatesChanged(e :any){
        setPolicyState(e.target.value)
        setValidation({...validationObject, hasState:(e.target.value !== "" ? true : false) });
        addErrorMessage(e.target.value === "", (e.target.value === "" ? validationObject.stateError : ""), errors, setErrors);
    }


    function isFormValid() {
        var isValid = true;
        var messages = [];

        var currentValidation = {...validationObject};

        if(effectiveDate === null || effectiveDate === undefined || !effectiveDate.isValid || !validationObject.hasEffectiveDate){
            isValid = false;
            messages.push(validationObject.effectiveDateError);
            currentValidation = {...currentValidation, hasEffectiveDate:false }
        }

        if(firstName === "" || firstName === undefined || firstName === null || !validationObject.firstNameError){
            isValid = false;
            messages.push(validationObject.firstNameError);
            currentValidation = {...currentValidation, hasFirstName:false }
        }

        if(lastName === "" || lastName === undefined || lastName === null || !validationObject.lastNameError){
            isValid = false;
            messages.push(validationObject.lastNameError);
            currentValidation = {...currentValidation, hasLastName:false }
        }

        if(policyState === "" || policyState === undefined || policyState === null || !validationObject.stateError){
            isValid = false;
            messages.push(validationObject.stateError);
            currentValidation = {...currentValidation, hasState:false }
        }

        setValidation({...currentValidation })
        setErrors(messages);
        
        return isValid;
    }

    if(isLoading){
        return loadingMessage();
    }else{
        //document.title = "Ford Insure";

        return <>
                <div className="container-quote w-[85vw] sm:w-[90vw] md:w-[90vw] lg:w-[90vw] xl:w-[60vw] pt-10">
                    <Breadcrumbs>
                        <h3 className="text-2xl pb-5 mt-0">Step 1 of 7</h3>
                    </Breadcrumbs>
                    <div className=" grid grid-cols-12 sm:grid-cols-12 md:grid-cols-12 lg:grid-cols-12 xl:grid-cols-12">
                        <div className="form-group col-span-8 md:col-span-2 xl:col-span-2 2xl:col-span-2 ">
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                
                            <DatePicker 
                                className="w-full"
                                label="Policy Start Date"
                                value={effectiveDate} 
                                shouldDisableDate={disablePriorDates}
                                onChange={(e) => {
                                        setEffectiveDate(e);
                                        setValidation({...validationObject, hasEffectiveDate: e!== null && e!==undefined })
                                        addErrorMessage(!e?.isValid, validationObject.effectiveDateError, errors, setErrors);
                                    }
                                } 
                                slotProps={{
                                    textField:{
                                        error: !validationObject.hasEffectiveDate
                                    }
                                }}
                                />
                                <FormHelperText className={"Mui-error"} >{(!validationObject.hasEffectiveDate ? validationObject.effectiveDateError : "")}</FormHelperText>
                            </LocalizationProvider>
                        </div>
                    </div>

                    <div className="grid grid-cols-12 gap-5 pt-12">                
                        <div className="form-group col-span-12 sm:col-span-2 md:col-span-2 lg:col-span-4 xl:col-span-4">
                            <TextField key="txtFirstName" 
                                id="txtFirstName" 
                                name="FirstName" className="p-1 w-full" 
                                label="First Name" 
                                variant="outlined" 
                                onChange={(e)=>{
                                    setFirstName(e.target.value)
                                    setValidation({...validationObject, hasFirstName:(e.target.value !== "" ? true : false) })
                                    addErrorMessage(e.target.value === "", validationObject.firstNameError, errors, setErrors);
                                }} 
                                value={ firstName } 
                                required={true}
                                error={!validationObject.hasFirstName}
                                helperText={!validationObject.hasFirstName ? "First Name is required" : ""}
                                />
                        </div>
                        <div className="form-group col-span-12 sm:col-span-2 md:col-span-2 lg:col-span-2 xl:col-span-2">
                            <TextField id="txtMiddleInitial" 
                                name="MiddleInitial" className="p-1"  
                                label="Middle Initial (optional)" 
                                variant="outlined" 
                                inputProps={{ maxLength: 1 }}
                                value={middleInitial}
                                onChange={(e)=>{setMiddleInitial(e.target.value)}} />
                        </div>
                        <div className="form-group col-span-12 sm:col-span-12 md:col-span-2 lg:col-span-4 xl:col-span-4">
                            <TextField 
                                id="txtLastName" 
                                name="LastName" 
                                className="p-1 w-full" 
                                label="Last Name" 
                                variant="outlined" 
                                value={lastName}
                                onChange={(e)=>{
                                        setLastName(e.target.value);
                                        setValidation({...validationObject, hasLastName:(e.target.value !== "" ? true : false) });
                                        addErrorMessage(e.target.value === "", validationObject.lastNameError, errors, setErrors);
                                    }   
                                }
                                required={true}
                                error={!validationObject.hasLastName} 
                                helperText={!validationObject.hasLastName ? "Last Name is required" : ""}
                                />
                        </div>
                        <div className="form-group col-span-12 sm:col-span-2 md:col-span-2 lg:col-span-2 xl:col-span-2">
                            <FormControl fullWidth>
                                <InputLabel id="lbl-ddlSuffix">Suffix (optional)</InputLabel>
                                <Select
                                    labelId="lbl-ddlSuffix"
                                    id="ddlSuffix"
                                    label="Suffix (optional)"
                                    value={suffix}
                                    onChange={(e)=> {setSuffix(e.target.value)}}>
                                    <MenuItem value="JR">JR</MenuItem>
                                    <MenuItem value="SR">SR</MenuItem>
                                    <MenuItem value="I">I</MenuItem>
                                    <MenuItem value="II">II</MenuItem>
                                    <MenuItem value="III">III</MenuItem>
                                    <MenuItem value="IV">IV</MenuItem>
                                    <MenuItem value="V">V</MenuItem>
                                    <MenuItem value="VI">VI</MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                        
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-6 lg:grid-cols-6 xl:grid-cols-6 gap-5 pt-12">
                        <div className="form-group col-span-12 sm:col-span-2 md:col-span-1 lg:col-span-1 xl:col-span-1">
                            <StatesDropDown 
                                className={""} 
                                updateSelectedState={onStatesChanged} 
                                defaultValue = {policyState}
                                value={policyState}
                                hasError={!validationObject.hasState} />
                                <FormHelperText className={"Mui-error"} >{(!validationObject.hasState ? validationObject.stateError : "")}</FormHelperText>
                        </div>
                    </div>
                    
            </div>
            <div className="mb-5 mt-28 p-5 bg-[#e0e1dd]">
                <div className="m-auto  w-[60vw]">
                    Information Disclosure: 
                    <br/><br/>
                    To offer you a fast, accurate quote, we use information from you and other sources, 
                    such as driving, claims, and credit histories. 
                    
                    By clicking "Agree and Continue", you agree that we have provided you with our&nbsp; 
                    <span className="hover:cursor-pointer hover:underline text-blue-700" onClick={(e)=>setIsTosOpen(true)}>Terms of Service</span>, &nbsp; 
                    <span className="hover:cursor-pointer hover:underline text-blue-700" onClick={(e)=>setIsPrivacyPolicyOpen(true)}>Privacy Policy</span> 
                    &nbsp;and <span className="hover:cursor-pointer hover:underline text-blue-700" onClick={(e)=>setIsCreditNoticeOpen(true)}>Credit Notice</span>. 
                    <br/>
                    <br/>
                    {/* <span className="hover:cursor-pointer float-right bg-[#0071eb] text-[#ffffff] p-2 rounded-md mt-10 active:bg-[#0a58ca]" onClick={NavgiateToDetailsPage}>Agree and Continue</span> */}
                    <Button variant="contained"  className="hover:cursor-pointer float-right bg-[#0071eb] text-[#ffffff] p-10 rounded-md mt-10 active:bg-[#0a58ca]" onClick={NavgiateToDetailsPage} disabled={isDisabledContinue}>
                        
                        <span id="button-text">
                            {isDisabledContinue ? <div className="spinner" id="spinner">Loading...</div> : "Agree and Continue"}
                        </span>
                    </Button>
                    <div className="clear-both"></div>
                </div>
            </div>

            <TermsOfServiceModal isOpen={isTosOpen} onCloseModal={()=>{setIsTosOpen(false)}} />          
            <PrivacyPolicyModal isOpen={isPrivacyPolicyOpen} onCloseModal={()=>{setIsPrivacyPolicyOpen(false)}} />          
            <CreditNoticeModal isOpen={isCreditNoticeOpen} onCloseModal={()=>{setIsCreditNoticeOpen(false)}} />            

            <Toast isOpen={isToastOpen} onClose={(e:any)=>{ setIsToastOpen(false); }} severity={toastSeverity} message={errors} />


            {/* 
        message,
        severity */}
        </>;
    }
}

export default Quote;